export default __webpack_public_path__ + "static/media/videoplayback.036d7504.mp4";